<template>
  <div>
    <div class="dialog-header">
      <h1>{{ title }}</h1>
    </div>
    <div class="dialog-content">
      <p>
        Hou bij het toevoegen van een afbeelding rekening met het volgende:
      </p>

      <ul>
        <li>Toegestane bestandsformaten zijn:<br />.SVG .PDF .PNG .JPG</li>

        <li>
          Voor het beste eindresultaat raden wij aan een<br />
          .SVG bestand te gebruiken.
        </li>
        <li>De minimale resolutie van een .PNG of .JPG bestand is 200 dpi.</li>
      </ul>
      <uploader
        class="button-holder"
        @file-success="fileSuccess"
        :options="uploadOptions"
        @file-progress="fileProgress"
      >
        <uploader-btn class="pill-button" :single="true" :attrs="uploadAttrs"
          >Bestand selecteren
        </uploader-btn>
        <div v-show="uploading" class="spinner-holder">
          <bouncing-spinner></bouncing-spinner>
        </div>
      </uploader>
    </div>
  </div>
</template>
<script>
import { uuidv4 } from '@/api/uuid'

export default {
  props: ['title', 'callback', 'fieldId'],
  data() {
    return {
      uploadOptions: {
        target: '/api/v3/print-store/customer-upload',
        testChunks: true,
        autoStart: true,
        chunkSize: 524288, // 0.5MB
        generateUniqueIdentifier: () => {
          return uuidv4()
        },
        permanentErrors: [404, 415, 422, 500, 501, 409]
      },
      uploadAttrs: {
        accept: 'image/jpeg, image/png, application/pdf, 	image/svg+xml'
      },
      uploading: false
    }
  },
  methods: {
    fileSuccess(rootFile, file, message, chunk) {
      const resp = JSON.parse(message)
      this.callback(this.fieldId, resp.url)
      this.$emit('close')
    },
    fileProgress() {
      this.uploading = true
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style-type: disc;
  list-style-position: outside;
  margin-bottom: 20px;
  margin-left: 17px;

  ul {
    margin-top: 3px;
    margin-bottom: 3px;
    /*     padding-left: 20px;
    padding-bottom: 0; */
  }
}

.uploader.button-holder {
  text-align: left;
  position: relative;

  .pill-button {
    text-transform: uppercase;
    background: var(--sub-color);
    height: 30px;
    border-radius: 15px;
    padding: 0 14px;
    color: white;
    font-size: 11px;
    line-height: 30px;
    font-weight: 400;
    transition: 0.3s background-color, 0.3s box-shadow;
    border: none;
    float: none;
    display: inline-block;

    /*     &.disabled {
      pointer-events: none;
      background-color: #bbbbbb;
    } */
  }
}

.spinner-holder {
  position: absolute;
  top: 0;
  left: 0;
  background: white;
  width: 100%;
  height: 100%;
}
</style>
